import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivityInfoModule } from '../activity-info/activity-info.module';
import { Inject } from '@angular/core';
import { SelectedService, selectedServiceToken } from 'go-modules/services/selected/selected.service';
import type { ActivityModel } from 'go-modules/models/activity/activity.schema';
import { TranslateModule } from '@ngx-translate/core';
import { ViewFrom } from '../activity-info/activity-info.component';
import { activityToken } from 'go-modules/models/activity/activity.factory';
import { NgxActivityService } from '@go-modules/services/activity/activity.service';
import { ENVIRONMENTS } from '@go-modules/services/environment-vars/environments';
import { EnvironmentVarsService } from '@go-modules/services/environment-vars/environment-vars.service';
import { LTI_ENVIRONMENT_MODES } from '@go-modules/services/environment-vars/environments';

@Component({
	selector: 'activity-task-overview',
	imports: [
		CommonModule,
		TranslateModule,
		ActivityInfoModule
	],
	templateUrl: './activity-task-overview.component.html',
	styleUrls: ['./activity-task-overview.component.scss']
})
export class ActivityTaskOverviewComponent implements OnInit {
	public readonly viewFrom = ViewFrom;
	public activity: ActivityModel;
	public environmentVarsService: EnvironmentVarsService;
	public limitActivityOption: boolean;

	constructor (
		public activityService: NgxActivityService,
		@Inject(selectedServiceToken) public selectedService: SelectedService,
		@Inject(activityToken) private ActivityModel
	) {
		this.environmentVarsService = EnvironmentVarsService.getInstance();
		const environment: any = this.environmentVarsService.get(EnvironmentVarsService.VAR.ENVIRONMENT) || {};
		this.limitActivityOption = environment.name === ENVIRONMENTS.LTI &&
			environment.mode === LTI_ENVIRONMENT_MODES.DEFAULT;
	}

	public ngOnInit (): void {
		this.activity = this.ActivityModel.model(this.selectedService.getActivity());
	}

	public shouldHideSourceMedia (): boolean {
		return this.activityService.shouldHideSourceMedia(this.activity);
	}

	public editActivity (): void {
		this.activityService.openNgxActivityEditor(this.activity, this.limitActivityOption)
			.subscribe((activity?: ActivityModel) => {
				if (activity) {
					this.activity = activity;
				}
			});
	}
}
